import { createSelector } from "reselect";

import reducerRegistry from "../../util/reducerRegistry";
import { REDUCER_NAME, SET_ERROR, SET_HOMENEWSCATEGORIES } from "./constants";

const initialState = {
  isReady: false,
  isError: false,
  newsCategories: [],
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HOMENEWSCATEGORIES:
      return {
        ...state,
        isReady: true,
        isError: false,
        newsCategories: action.data,
      };
    case SET_ERROR:
      return {
        ...state,
        isReady: false,
        isError: true,
      };
    default:
      return state;
  }
};

const getState = (state) => {
  if (state[REDUCER_NAME]) {
    return state[REDUCER_NAME];
  }
  return initialState;
};

export const selectIsReady = createSelector(getState, (n) => n.isReady);

export const selectIsError = createSelector(getState, (n) => n.isError);

export const selectNewsCategories = createSelector(
  getState,
  (n) => n.newsCategories
);

reducerRegistry.register(REDUCER_NAME, reducer);
